import Icon from '../components/Icon.vue'

Icon.register({"magnet":{"width":512,"height":512,"paths":[{"d":"M164.1 160H12C5.4 160 0 154.6 0 148V68C0 48.1 16.1 32 36 32H140C159.9 32 176 48.1 176 68V148C176.1 154.6 170.7 160 164.1 160zM512.1 148V67.9C512.1 48 496 31.9 476.1 31.9H372.1C352.2 31.9 336.1 48 336.1 67.9V147.9C336.1 154.5 341.5 159.9 348.1 159.9H500.1C506.7 160 512.1 154.6 512.1 148zM348.1 192C341.5 192 336.1 197.4 336.1 204V256C336.1 384.1 176.1 383.9 176.1 256V204C176.1 197.4 170.7 192 164.1 192H12.1C5.4 192 0.1 197.4 0.1 204.1 0.2 225.5 0.7 244.4 0.1 257.4 0.1 408 136.3 504 256.9 504 377.5 504 512 408 512 257.3 511.4 244.5 511.8 224.3 512 204.1 512 197.4 506.7 192 500 192H348.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/magnet.js
// module id = null
// module chunks = 